import { DH } from '../../../utils/dataHooks';

/**
 * GooglePay button loads by async manner after widget shown to user
 * @summary data-attribute for wrapper with data-hook=DH.GooglePay.Button - will be used in tests to wait for the button to be displayed
 */
/**
 * GooglePay button loads by async manner after widget shown to user
 * @summary selector for using in test (with real gpay button - ex. take screenshot in storybook) for wait for the button to be displayed
 */
export const googlePayButtonSelector = `[data-hook="${DH.GooglePay.Button}"][data-test-visible="true"]`;

export const pendingShippingOption = {
  id: 'pendingShippingOptionPendingId',
  label: 'paymentSheet.shippingOption.pending.title',
  description: '', // required - Google have bug with types
} as const;

export const callbackIntents = {
  PAYMENT_AUTHORIZATION: 'PAYMENT_AUTHORIZATION',
  SHIPPING_ADDRESS: 'SHIPPING_ADDRESS',
  SHIPPING_OPTION: 'SHIPPING_OPTION',

  PAYMENT_METHOD: 'PAYMENT_METHOD',
  OFFER: 'OFFER',
} as const;

export const defaultShippingOptionIndex = 0;
